import type { Node as ProseMirrorNode } from "prosemirror-model";
import { shallowRef } from "vue";

import type { ConversationId } from "@ctrl/controller-rpc";

import type { ChatAttachment } from "./useAttachments";

/**
 * Transient store for a message submitted on the Agent home that needs to be
 * sent once AgentConversation mounts for the newly-created conversation.
 */
export type PendingMessage = {
  conversationId: ConversationId;
  doc: ProseMirrorNode;
  text: string;
  attachments?: ChatAttachment[];
  /**
   * When `false`, the composer is filled with `text` but the message is not sent
   * until the user submits. When omitted or `true`, the message is sent on mount
   * (existing behavior).
   */
  sendImmediately?: boolean;
};

// Must be shallowRef, not ref: Vue's ref() deeply proxies object values, which
// would wrap the ProseMirrorNode in a Proxy. ProseMirror uses referential equality
// (===) to compare NodeType instances (e.g. node.type === schema.nodes.integration),
// so a proxied node.type would never match, causing extractContext to miss all
// integration nodes in the doc.
export const pendingMessage = shallowRef<PendingMessage | null>(null);
